// @flow

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: React.Node,
  className?: string,
  label?: string
};

const defaultProps = {
  className: undefined,
  label: undefined
};

const FilterGroupDiv = styled.div(
  {
    display: 'flex',
    flexDirection: 'column'
  },
  props => ({
    paddingTop: props.theme.spacing.small,
    '&:first-of-type': {
      paddingTop: 0
    }
  })
);

const Label = styled.div(({ theme }: { theme: Theme }) => ({
  opacity: 0.8,
  textTransform: 'uppercase',
  marginLeft: theme.spacing.tiny,
  fontSize: theme.fontSize.tiny
}));

function FilterGroup({ children, className, label }: Props) {
  return (
    <FilterGroupDiv className={className}>
      {label && <Label>{label}</Label>}
      {children}
    </FilterGroupDiv>
  );
}

FilterGroup.defaultProps = defaultProps;

export default FilterGroup;
